// Traccia le chiamate WS in volo, così l'auto-logout per inattività può essere
// sospeso mentre un'operazione è in corso: al crescere del volume nel DB le
// operazioni potrebbero allungarsi e non vogliamo sloggare l'utente a metà.
let inFlight = 0;
const idleListeners = new Set();

export function beginWsCall() {
    inFlight++;
}

export function endWsCall() {
    inFlight = Math.max(0, inFlight - 1);
    if (inFlight === 0) {
        // Nessuna chiamata più in volo: notifica gli ascoltatori così il conteggio
        // di inattività riparte da adesso (il completamento conta come attività).
        idleListeners.forEach(fn => fn());
    }
}

export function isWsBusy() {
    return inFlight > 0;
}

// Registra un callback invocato quando l'ultima chiamata WS in volo si conclude.
// Ritorna una funzione per annullare la registrazione.
export function onWsIdle(listener) {
    idleListeners.add(listener);
    return () => idleListeners.delete(listener);
}
